import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {
    type GroupFromAPI,
    type GroupSetting,
    type FormData,
    type Department,
} from 'web-app/react/institution/settings/edit-group/models';

const domain = 'EDIT_GROUP';

export const {
    action: fetchGroup,
    success: fetchGroupSuccess,
    failed: fetchGroupFailed,
} = createAction(
    `${domain}/FETCH_GROUP`,
    (groupId: string, shouldReset?: boolean) => ({groupId, shouldReset}),
    (group: GroupFromAPI) => ({group}),
);

export const {
    action: fetchDepartments,
    success: fetchDepartmentsSuccess,
    failed: fetchDepartmentsFailed,
} = createAction(
    `${domain}/FETCH_DEPARTMENTS`,
    (institutionId: string) => ({institutionId}),
    (departments: Department[]) => ({departments}),
);

export const {
    action: fetchGroupSettings,
    success: fetchGroupSettingsSuccess,
    failed: fetchGroupSettingsFailed,
} = createAction(
    `${domain}/FETCH_GROUP_SETTINGS`,
    (groupId: string) => ({groupId}),
    (settings: GroupSetting[]) => ({settings}),
);

export const {
    action: updateGroup,
    success: updateGroupSuccess,
    failed: updateGroupFailed,
} = createAction(
    `${domain}/UPDATE_GROUP`,
    (institutionId: string, groupId: string, formData: FormData) => ({institutionId, groupId, formData}),
    () => ({}),
);

export const {
    action: updateGroupSetting,
    success: updateGroupSettingSuccess,
    failed: updateGroupSettingFailed,
} = createAction(
    `${domain}/UPDATE_GROUP_SETTINGS`,
    (groupId: string, setting: string, value: boolean, option: any, groupTitle: string) => ({
        groupId,
        setting,
        value,
        option,
        groupTitle,
    }),
    () => ({}),
);

export const {
    action: deleteGroup,
    success: deleteGroupSuccess,
    failed: deleteGroupFailed,
} = createAction(
    `${domain}/DELETE_GROUP`,
    (groupId: string) => ({groupId}),
    () => ({}),
);
